import component from './ja-JP/component';
import globalHeader from './ja-JP/globalHeader';
import menu from './ja-JP/menu';
import pages from './ja-JP/pages';
import pwa from './ja-JP/pwa';
import settingDrawer from './ja-JP/settingDrawer';
import settings from './ja-JP/settings';
import fixOverlay from './ja-JP/fix_overlay';
import fixOpenapi from './ja-JP/fix_openapi';
import fixAdminMisc from './ja-JP/fix_adminmisc';
import fixBilling from './ja-JP/fix_billing';
import fixComponents from './ja-JP/fix_components';
import fixConsoleMisc from './ja-JP/fix_consolemisc';
import fixGap from './ja-JP/fix_gap';
import fixSystemconfig from './ja-JP/fix_systemconfig';
import fixTenant from './ja-JP/fix_tenant';
import fixVoiceClone from './ja-JP/fix_voiceclone';
import fixTodo from './ja-JP/fix_todo';


export default {
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.preview.down.block':
    'このページをローカルプロジェクトにダウンロードしてください',
  'app.welcome.link.fetch-blocks': 'すべてのブロックを取得',
  'app.welcome.link.block-list':
    'ブロック開発フレームワークを使用して迅速に標準的なページを作成',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
